import { render, staticRenderFns } from "./page_navigation_menu.vue?vue&type=template&id=1010a8d6&scoped=true"
import script from "./page_navigation_menu.vue?vue&type=script&lang=js"
export * from "./page_navigation_menu.vue?vue&type=script&lang=js"
import style0 from "./page_navigation_menu.vue?vue&type=style&index=0&id=1010a8d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1010a8d6",
  null
  
)

export default component.exports